import React from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import Image from "../../components/elements/Image";
import siteLogo from "../../assets/images/logo.png";
import { useQuery } from '@tanstack/react-query';
import { postMenuDetails } from '../../services/postService';
import Button from "../../components/form/Button";
import { useBistroNavigation } from '../../hooks/useBistroNavigation';

const MenuDetails = () => {
    const navigate = useNavigate();
    const params = useParams();
    const slug = params?.slug;
    const tableNumber = params?.table;
    const { data: details } = useQuery({
        queryKey: ["menu-details", slug],
        queryFn: async () => {
        const res = await postMenuDetails({ slug: slug });
        return res?.data;
        },
        enabled: !!slug,
    });
    const { getPath, config } = useBistroNavigation();

    return (
        <div className="w-full xls:max-w-sm bg-white rounded-2xl shadow-sm overflow-hidden pb-0 h-screen xls:mx-auto flex flex-col">
            <div className="border-b border-[#F4F4F4] px-4 py-3">
                <div className="flex items-center justify-between">
                  <Button
                    buttonFunction={() => navigate(-1)}
                    buttonClasses="text-blue-600 hover:text-blue-700 font-medium text-sm bg-blue-100 rounded-full w-7 h-7 hover:bg-transparent flex-shrink-0"
                    buttonIcon={"fa-regular fa-arrow-left text-sm"}
                    buttonIconPosition="left"
                  />
                  <div className="flex items-center gap-2">
                    <Link to={getPath((tableNumber && tableNumber !== undefined)?`/home/table/${tableNumber}`:`/home`)} className="w-10 h-10 overflow-hidden rounded-full">
                      <Image src={config?.logo} classes={"object-cover"} />
                    </Link>
                  </div>
                </div>

                <div className="text-sm text-gray-500 mt-2 bg-blue-100 rounded-lg py-1 px-4">
                    <span className="hover:text-blue-600 cursor-pointer text-blue-800 font-medium" onClick={() => navigate(getPath("/menu"))}>
                        Menu
                    </span> 
                    <span className="mx-1">/</span>
                    <span className="text-blue-600 font-medium">{details?.content?.en?.title}</span>
                </div>
            </div>

            <div className="px-4 py-6 flex flex-col space-y-4 overflow-auto">
                <div className="w-full h-64 bg-gray-100 rounded-lg overflow-hidden">
                    <img
                        src={details?.coverMedia?.url}
                        alt={details?.coverMedia?.name}
                        className="w-full h-full object-cover"
                    />
                </div>

                <div className="flex flex-col space-y-2">
                    <h2 className="text-2xl font-semibold text-gray-900">{details?.content?.en?.title}</h2>
                    <p className="text-lg text-gray-600">{details?.category}</p>
                </div>

                <div className="space-y-2 bg-blue-50 rounded-lg py-4 px-5 mb-6 text-left">
                    <h3 className="font-medium text-gray-800">Variants & Prices:</h3>
                    <div className="flex flex-col space-y-2 divide-y-[1px] divide-emerald-600/20">
                        {details?.variants?.length>0 && details.variants.map((variant, index) => (
                            <div key={index} className="flex justify-between py-2 !m-0">
                                <span className="text-gray-700">{variant.name}</span>
                                <span className="text-blue-600 font-semibold">{`$ ${variant.price}`}</span>
                            </div>
                        ))}
                    </div>
                </div>

                <div className="space-y-2">
                    <h3 className="font-medium text-gray-800">Description:</h3>
                    <p className="text-gray-700">{details?.content?.en?.content}</p>
                </div>

                {/* Additional Images */}
                {/* <div className="flex space-x-4 mt-4">
                    {product.images.slice(1).map((image, index) => (
                        <div key={index} className="w-1/2 h-40 overflow-hidden rounded-lg">
                            <img
                                src={image}
                                alt={`${product.name}-image-${index + 2}`}
                                className="w-full h-full object-cover"
                            />
                        </div>
                    ))}
                </div> */}
            </div>
        </div>
    );
};

export default MenuDetails;
